import React, { useState } from "react";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";

const Contact = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const { fullName, email, phone, subject, message } = formData;

    if (!fullName || !email || !phone || !subject || !message) {
      toast.error("Please complete all required fields.");
      return;
    }

    toast.success(
      "Thank you for contacting us! Our team will get back to you shortly."
    );

    setFormData({
      fullName: "",
      email: "",
      phone: "",
      subject: "",
      message: "",
    });
  };

  return (
    <section className="sx-contact">
      <div className="sx-contact-container">
        {/* HEADER */}
        <div className="sx-contact-head">
          <h2>Get in Touch</h2>
          <p>
            Have a question about printers, orders, or support? Our team is here
            to help.
          </p>
        </div>

        <div className="sx-contact-grid">
          {/* FORM */}
          <div className="sx-contact-form">
            <h4>Send Us a Message</h4>

            <form onSubmit={handleSubmit}>
              <div className="sx-form-grid">
                <InputField
                  id="fullName"
                  label="Full Name"
                  value={formData.fullName}
                  onChange={handleChange}
                />
                <InputField
                  id="email"
                  label="Email Address"
                  type="email"
                  value={formData.email}
                  onChange={handleChange}
                />
                <InputField
                  id="phone"
                  label="Phone Number"
                  value={formData.phone}
                  onChange={handleChange}
                />
                <InputField
                  id="subject"
                  label="Subject"
                  value={formData.subject}
                  onChange={handleChange}
                />

                <div className="sx-form-full">
                  <label>Message *</label>
                  <textarea
                    id="message"
                    placeholder="Write your message here..."
                    value={formData.message}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <button type="submit" className="sx-submit-btn">
                Submit Message
              </button>
            </form>
          </div>

          {/* INFO */}
          <div className="sx-contact-info">
            <h5>Contact Information</h5>

            <InfoRow icon="ph-envelope" text="info@awaneez.com" />
            <InfoRow
              icon="ph-map-pin"
              text="2234 N Federal Hwy, Ste 3162 Boca Raton, Florida 33431-7710"
            />
            <InfoRow icon="ph-phone" text="+1-786-761-8824" />

            <div className="sx-contact-actions">
              <Link to="/order-track">Track Your Order</Link>
              <Link to="/return-order">Return & Exchange</Link>
            </div>
          </div>
        </div>
      </div>

      {/* CSS */}
      <style>{`
        /* ================= CONTACT ================= */
        .sx-contact {
          padding: 90px 0;
          background: #f7f9fc;
        }

        .sx-contact-container {
          max-width: 1200px;
          margin: auto;
          padding: 0 20px;
        }

        /* HEADER */
        .sx-contact-head {
          text-align: center;
          max-width: 700px;
          margin: 0 auto 60px;
        }

        .sx-contact-head h2 {
          font-size: 36px;
          font-weight: 800;
          color: #111;
          margin-bottom: 10px;
        }

        .sx-contact-head p {
          font-size: 16px;
          color: #555;
          line-height: 1.7;
        }

        /* GRID */
        .sx-contact-grid {
          display: grid;
          grid-template-columns: 2fr 1fr;
          gap: 40px;
        }

        /* FORM */
        .sx-contact-form {
          background: #ffffff;
          padding: 40px;
          box-shadow: 0 10px 30px rgba(0,0,0,0.08);
        }

        .sx-contact-form h4 {
          font-size: 20px;
          font-weight: 700;
          margin-bottom: 30px;
        }

        .sx-form-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 20px;
        }

        .sx-form-full {
          grid-column: 1 / -1;
        }

        .sx-form-full textarea {
          width: 100%;
          min-height: 140px;
          padding: 14px;
          border: 1px solid #ddd;
          font-size: 14px;
        }

        .sx-contact-form label {
          display: block;
          font-size: 14px;
          font-weight: 600;
          margin-bottom: 6px;
        }

        /* SUBMIT */
        .sx-submit-btn {
          margin-top: 30px;
          width: 100%;
          background: #111;
          color: #fff;
          border: none;
          padding: 16px;
          font-size: 15px;
          font-weight: 700;
          cursor: pointer;
          transition: background .25s ease;
        }

        .sx-submit-btn:hover {
          background: #000;
        }

        /* INFO */
        .sx-contact-info {
          background: #ffffff;
          padding: 36px;
          box-shadow: 0 10px 30px rgba(0,0,0,0.08);
        }

        .sx-contact-info h5 {
          font-size: 18px;
          font-weight: 700;
          margin-bottom: 26px;
        }

        .sx-info-row {
          display: flex;
          gap: 14px;
          margin-bottom: 22px;
          font-size: 14px;
          color: #444;
          line-height: 1.6;
        }

        .sx-info-row i {
          font-size: 20px;
          color: #0b5ed7;
        }

        /* ACTION LINKS */
        .sx-contact-actions {
          margin-top: 30px;
          display: flex;
          flex-direction: column;
          gap: 14px;
        }

        .sx-contact-actions a {
          background: #0b5ed7;
          color: #fff;
          padding: 14px 16px;
          text-decoration: none;
          font-weight: 700;
          text-align: center;
          transition: background .25s ease;
        }

        .sx-contact-actions a:hover {
          background: #084bb0;
        }

        /* MOBILE */
        @media(max-width: 900px) {
          .sx-contact-grid {
            grid-template-columns: 1fr;
          }

          .sx-form-grid {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
    </section>
  );
};

/* ---------------- COMPONENTS ---------------- */

const InputField = ({ id, label, value, onChange, type = "text" }) => (
  <div>
    <label>{label} *</label>
    <input
      id={id}
      type={type}
      value={value}
      onChange={onChange}
      placeholder={label}
      style={{
        width: "100%",
        padding: "14px",
        border: "1px solid #ddd",
        fontSize: "14px",
      }}
    />
  </div>
);

const InfoRow = ({ icon, text }) => (
  <div className="sx-info-row">
    <i className={`ph ${icon}`} />
    <span>{text}</span>
  </div>
);

export default Contact;
